import {
  CreateCashBackAutoRedemptionSetting,
  CreateDigitalGiftCardAutoRedemptionSetting,
  CreatePhysicalGiftCardAutoRedemptionSetting,
  CreatePointsTransferAutoRedemptionSetting,
} from '@features/auto-redemption-settings/services/auto-redemption-setting-api/auto-redemption-setting-api.service';
import { createAction, props } from '@ngrx/store';
import {
  AutoRedemptionUpdate,
  MFAAutoRedemption,
  MFAOneTimeRedemption,
  MFAOutcome,
  MFAShoppingCart,
  OneTimeRedemptionCashBack,
  OneTimeRedemptionEverydaySpend,
  OneTimeRedemptionPointsTransfer,
} from '@rd/core/mfa/types';

export enum MFAActionTypes {
  REDIRECT_MFA = '[MFA] REDIRECT MFA',
  RESTORE_STATE_FROM_MFA = '[MFA] RESTORE STATE FROM MFA',
  INITIATE_ONE_TIME_REDEMPTION_POINTS_TRANSFER = '[MFA] INITIATE ONE TIME REDEMPTION POINTS TRANSFER',
  INITIATE_ONE_TIME_REDEMPTION_EVERYDAY_SPEND = '[MFA] INITIATE ONE TIME REDEMPTION EVERYDAY SPEND',
  INITIATE_ONE_TIME_REDEMPTION_CASHBACK = '[MFA] INITIATE ONE TIME REDEMPTION CASHBACK',
  INITIATE_SHOPPING_CART_REDEMPTION = '[MFA] INITIATE SHOPPING CART REDEMPTION',
  INITIATE_AUTO_REDEMPTION_UPDATE = '[MFA] INITIATE AUTO REDEMPTION UPDATE',
  INITIATE_AUTO_REDEMPTION = '[MFA] INITIATE AUTO REDEMPTION',
}

export const RedirectMFA = createAction(
  MFAActionTypes.REDIRECT_MFA,
  props<{ level: number }>(),
);

export const RestoreStateFromMFA = createAction(
  MFAActionTypes.RESTORE_STATE_FROM_MFA,
  props<{
    data: MFAAutoRedemption | MFAOneTimeRedemption | MFAShoppingCart;
    outcome: MFAOutcome;
  }>(),
);

export const InitiateOneTimeRedemptionCashback = createAction(
  MFAActionTypes.INITIATE_ONE_TIME_REDEMPTION_CASHBACK,
  props<{
    otrData: OneTimeRedemptionCashBack;
  }>(),
);

export const InitiateOneTimeRedemptionPointsTransfer = createAction(
  MFAActionTypes.INITIATE_ONE_TIME_REDEMPTION_POINTS_TRANSFER,
  props<{
    otrData: OneTimeRedemptionPointsTransfer;
  }>(),
);

export const initiateOneTimeRedemptionEverydaySpend = createAction(
  MFAActionTypes.INITIATE_ONE_TIME_REDEMPTION_EVERYDAY_SPEND,
  props<{
    otrData: OneTimeRedemptionEverydaySpend;
  }>(),
);

export const InitiateShoppingCartRedemption = createAction(
  MFAActionTypes.INITIATE_SHOPPING_CART_REDEMPTION,
);

export const InitiateAutoRedemption = createAction(
  MFAActionTypes.INITIATE_AUTO_REDEMPTION,
  props<{
    arData:
      | CreatePointsTransferAutoRedemptionSetting
      | CreateCashBackAutoRedemptionSetting
      | CreatePhysicalGiftCardAutoRedemptionSetting
      | CreateDigitalGiftCardAutoRedemptionSetting;
    isEverydaySpend?: boolean;
  }>(),
);

export const InitiateAutoRedemptionUpdate = createAction(
  MFAActionTypes.INITIATE_AUTO_REDEMPTION_UPDATE,
  props<{
    arData: AutoRedemptionUpdate;
  }>(),
);

export type RedirectMFAReturnType = ReturnType<typeof RedirectMFA>;

export type InitiateOneTimeRedemptionCashbackReturnType = ReturnType<
  typeof InitiateOneTimeRedemptionCashback
>;
export type InitiateOneTimeRedemptionPointsTransferReturnType = ReturnType<
  typeof InitiateOneTimeRedemptionPointsTransfer
>;
export type InitiateOneTimeRedemptionEverydaySpendReturnType = ReturnType<
  typeof initiateOneTimeRedemptionEverydaySpend
>;
export type InitiateShoppingCartReturnType = ReturnType<
  typeof InitiateShoppingCartRedemption
>;
export type InitiateAutoRedemptionReturnType = ReturnType<
  typeof InitiateAutoRedemption
>;
export type InitiateAutoRedemptionUpdateReturnType = ReturnType<
  typeof InitiateAutoRedemptionUpdate
>;

export type InitiateRedemptionActionType =
  | InitiateOneTimeRedemptionCashbackReturnType
  | InitiateOneTimeRedemptionPointsTransferReturnType
  | InitiateShoppingCartReturnType
  | InitiateAutoRedemptionReturnType
  | InitiateAutoRedemptionUpdateReturnType;
